// js/sections/AnnouncementBarSection.js
import { Animation, Accessibility } from 'utils';
import Delegate from 'ftdomdelegate';

class AnnouncementBarSection extends HTMLElement {
  constructor() {
    super();
    
    this.domDelegate = new Delegate(this);
    this.settings = JSON.parse(this.getAttribute("data-settings")) || {};
    this.isOpen = false;
    if (this.settings["showNewsletter"]) {
      document.documentElement.style.setProperty("--announcement-bar-button-width", this.querySelector(".announcement-bar__button").clientWidth + "px");
    } else {
      document.documentElement.style.removeProperty("--announcement-bar-button-width");
    }
    this._attachListeners();
  }
  onSelect() {
    if (this.settings["showNewsletter"] && !this.isOpen) {
      this._toggleNewsletter();
    }
  }
  onDeselect() {
    if (this.settings["showNewsletter"] && this.isOpen) {
      this._toggleNewsletter();
    }
  }
  disconnectedCallback() {
    this.domDelegate.off();
  }
  connectedCallback() {
    // Re-initialize if needed when element is connected
  }
  _attachListeners() {
    this.domDelegate.on("click", '[data-action="toggle-newsletter"]', this._toggleNewsletter.bind(this));
    this.domDelegate.on("keyup", this._handleKey.bind(this));
  }
  _toggleNewsletter() {
    let togglerElement = this.querySelector(".announcement-bar__button"), newsletterElement = this.querySelector(".announcement-bar__newsletter");
    if (togglerElement.getAttribute("aria-expanded") === "false") {
      togglerElement.setAttribute("aria-expanded", "true");
      newsletterElement.setAttribute("aria-hidden", "false");
      Animation.slideDown(newsletterElement, () => {
        Accessibility.trapFocus(newsletterElement, "announcement-bar");
      });
    } else {
      togglerElement.setAttribute("aria-expanded", "false");
      newsletterElement.setAttribute("aria-hidden", "true");
      Animation.slideUp(newsletterElement);
      Accessibility.removeTrapFocus(newsletterElement, "announcement-bar");
    }
    this.isOpen = !this.isOpen;
  }
  _handleKey(event2) {
    if (event2.key === "Escape" && this.isOpen) {
      this._toggleNewsletter();
    }
  }
}
if (!window.customElements.get("cos-announcement-bar")) window.customElements.define("cos-announcement-bar", AnnouncementBarSection);
